export type ValidationResult = { valid: true } | { valid: false; error: string }

interface ValidateRatingSubmissionInput {
  diveStatus: string
  raterId: string
  rateeId: string
  isRaterParticipantOrHost: boolean
  existingRating: boolean
  comment: string | null
}

export const validateRatingSubmission = (
  input: ValidateRatingSubmissionInput
): ValidationResult => {
  if (input.diveStatus !== 'completed') {
    return {
      valid: false,
      error: 'Dive must be completed before ratings can be submitted'
    }
  }

  if (input.raterId === input.rateeId) {
    return { valid: false, error: 'You cannot rate yourself' }
  }

  if (!input.isRaterParticipantOrHost) {
    return { valid: false, error: 'You did not participate in this dive' }
  }

  if (input.existingRating) {
    return {
      valid: false,
      error: 'You have already rated this user for this dive'
    }
  }

  if (input.comment !== null && input.comment.length > 500) {
    return { valid: false, error: 'Comment must be 500 characters or fewer' }
  }

  return { valid: true }
}
